import { Progress as AntProgress, ProgressProps } from 'antd';
import styled from '@emotion/styled';

const StyledProgress = styled(AntProgress)`
  .ant-progress-inner {
    height: 16px !important;

    .ant-progress-bg {
      height: 16px !important;

      &::before {
        position: absolute;
        inset: 0;
        background: rgb(182, 181, 181);
        border-radius: 100px;
        animation-duration: -0s !important;
      }
      &:after {
        position: absolute;
        inset: 0;
        background-image: linear-gradient(
          133deg,
          #d9d9d9 7%,
          transparent 0%,
          transparent 45%,
          #d9d9d9 48%,
          #d9d9d9 57%,
          transparent 61%,
          transparent 79%
        );
        background-size: 16px 16px;
        background-position: 0 0;
        border-radius: 100px;
        opacity: 1;
        animation: animateStripes 1s linear infinite;
        content: '';
      }

      @keyframes animateStripes {
        0% {
          background-position: 0 0;
        }

        100% {
          background-position: 1rem 0;
        }
      }
    }
  }
  .ant-progress-status-active {
    .ant-progress-bg::before {
      animation-duration: -0s !important;
    }
  }
`;

export const Progress = (props: ProgressProps) => {
  return <StyledProgress {...props} />;
};
